/**
 * Tabs Component - 밑줄형 탭 (선택 탭 = primary 색 + 밑줄)
 *
 *   const [tab, setTab] = useState<'a' | 'b'>('a');
 *   <Tabs
 *     items={[{ key: 'a', label: '연결 정보' }, { key: 'b', label: '테이블 선택' }]}
 *     active={tab}
 *     onChange={setTab}
 *   />
 *   {tab === 'a' && …}
 *
 * - 탭 내용은 사용하는 쪽에서 active 값에 따라 그림 (컴포넌트는 탭 줄만 담당)
 * - 스타일: index.css "Tabs" 섹션
 */

import { ReactNode } from 'react';

export interface TabItem<K extends string> {
  key: K;
  label: ReactNode;
}

interface TabsProps<K extends string> {
  items: TabItem<K>[];
  active: K;
  onChange: (key: K) => void;
  className?: string;
}

export function Tabs<K extends string>({ items, active, onChange, className = '' }: TabsProps<K>) {
  return (
    <div className={`tabs ${className}`.trim()} role="tablist">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          role="tab"
          aria-selected={active === item.key}
          className={`tabs-item${active === item.key ? ' active' : ''}`}
          onClick={() => onChange(item.key)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
